export const GET_JOURNALISTS = 'GET_JOURNALISTS';
